import React from 'react';

// Colori delle righe corrispondenti nelle card di "Da gestire":
// viola = da registrare, giallo = da scrivere, verde = programmati.
export const COLORE_RIPRESE = '#7C3AED';
export const COLORE_TESTI = '#D97706';
export const COLORE_PROGRAMMARE = '#059669';

// Contatore piatto: pallino colorato, numero, etichetta. Grigio quando è a
// zero, così l'occhio va solo dove c'è lavoro.
export const Contatore: React.FC<{ n: number; label: string; colore: string; title: string }> = ({ n, label, colore, title }) => (
  <span
    className="inline-flex items-center gap-1.5 text-sm"
    title={title}
    style={{ color: n > 0 ? undefined : '#8B92A0' }}
  >
    <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: n > 0 ? colore : '#DDE0E6' }} />
    <span className="font-semibold tabular-nums">{n}</span>
    <span className="text-slate-500 dark:text-slate-400">{label}</span>
  </span>
);

// Quanti profili hanno un avviso aperto: gli stessi tre avvisi che compaiono
// in cima alle card di "Da gestire" (riprese, testi, programmazione).
const ContatoriProfili: React.FC<{ riprese: number; testi: number; daProgrammare: number }> = ({ riprese, testi, daProgrammare }) => (
  <div className="flex flex-wrap items-center gap-x-5 gap-y-1.5">
    <Contatore n={riprese} label={riprese === 1 ? 'profilo richiede riprese' : 'profili richiedono riprese'} colore={COLORE_RIPRESE} title="Clienti in ritardo sul ritmo mensile delle riprese e senza riprese già fissate in agenda" />
    <Contatore n={testi} label={testi === 1 ? 'profilo senza testi' : 'profili senza testi'} colore={COLORE_TESTI} title="Clienti con le riprese fissate ma senza testi pronti da registrare" />
    <Contatore n={daProgrammare} label={daProgrammare === 1 ? 'profilo da programmare' : 'profili da programmare'} colore={COLORE_PROGRAMMARE} title="Clienti con reel già registrati che bastano a completare il mese: vanno solo programmati" />
  </div>
);

export default ContatoriProfili;
